import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";


export const FetchPatientApi = async (params) => {
    const callResponse = await axios({
      url: endpoints.FetchPatient,
      method: "get",
      headers: getHeaders(),
      params,
    })
      .then((response) => response.data)
      .catch((err) => ({status:0,response:err.response,code:err.response.status}));
  
    return callResponse;
  };
  
  export const CreatePatientApi = async (data) => {
    const callResponse = await axios({
      url: endpoints.CreatePatient,
      method: "post",
      headers: getHeaders(),
      data,
    })
      .then((response) => response.data)
      .catch((err) => ({status:0,response:err.response,code:err.response.status}));
  
    return callResponse;
  };


  export const UpdatePatientApi = async data => {
    const callResponse = await axios({
      url: endpoints.updatePatient,
      method: "patch",
      headers: getHeaders(),
      data,
    })
      .then(response => response.data)
      .catch(err => err.response.data);
  
    return callResponse;
  };
  

  export const getPatientByIdApi = async params => {
    const callResponse = await axios({
      url: endpoints.FetchPatientById,
      method: "get",
      headers: getHeaders(),
      params,
    })
      .then(response => response.data)
      .catch(err => err.response.data);
  
    return callResponse;
  };